import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

export enum CallState {
  offline,
  waiting,
  connected

}

@Injectable({
  providedIn: 'root'
})
export class SipHeaderService {

  private isCallable = new BehaviorSubject<CallState>(CallState.offline); // начальное значение false
  isCallable$ = this.isCallable.asObservable(); // поток для подписки


  constructor() {
  }

  setState(value: CallState) {
    this.isCallable.next(value);
  }

  // получить текущее значение (если нужно)
  getCurrentState(): CallState {
    return this.isCallable.getValue();
  }
}
